import { type ReactNode } from 'react'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { ContentLayout } from '@/components/ContentLayout'
import { ScopeChangeRequestHeader } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestHeader'
import { TableSearchbar } from '@/components/TableSearchbar'
import { TableHost } from '@/components/Table'
import { TableScroller } from '@/components/Table/TableScroller'
import {
  SideSheet,
  SideSheetHostView,
  SideSheetMain,
} from '@/components/SideSheet'
import styles from './ScopeChangeRequests.module.css'

export interface ScopeChangeRequestsProps {
  /**
   * The workspace filter shown as the header's heading.
   */
  heading: ReactNode
  isSideSheetVisible?: boolean
  statusFilter: ReactNode
  searchText: string
  onSearchTextChange: (text: string) => void
  table: ReactNode
  detailsPanel: ReactNode
  /**
   * The change request dialogs.
   */
  children?: ReactNode
}

export function ScopeChangeRequests({
  heading,
  isSideSheetVisible,
  statusFilter,
  searchText,
  onSearchTextChange,
  table,
  detailsPanel,
  children,
}: ScopeChangeRequestsProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <div className={styles.root} ref={scrollRef}>
      <ScopeChangeRequestHeader scrollOffset={scrollOffset}>
        {heading}
      </ScopeChangeRequestHeader>
      <SideSheetHostView sheetVisible={isSideSheetVisible}>
        <SideSheetMain>
          {statusFilter}
          <ContentLayout>
            <TableHost>
              <TableSearchbar
                searchText={searchText}
                onSearchTextChange={onSearchTextChange}
              />
              <TableScroller>{table}</TableScroller>
            </TableHost>
          </ContentLayout>
        </SideSheetMain>
        <SideSheet>{detailsPanel}</SideSheet>
      </SideSheetHostView>
      {children}
    </div>
  )
}
